import { Builder } from '@builder.io/react';

import Comparison from './index';

Builder.registerComponent(Comparison, {
  name: 'Comparison',
  inputs: [
    {
      name: 'product',
      type: 'string',
      defaultValue: 'Scale Rapid'
    },
    { name: 'inverted', type: 'boolean', defaultValue: false },
    {
      name: 'comparison',
      type: 'object',
      subFields: [
        {
          name: 'competitor',
          type: 'string'
        },
        {
          name: 'features',
          type: 'list',
          defaultValue: [
            {
              title: 'Title',
              ourProduct: true,
              competitor: false
            }
          ],
          subFields: [
            {
              name: 'title',
              type: 'string',
              defaultValue: 'Title'
            },
            {
              name: 'disclaimer',
              type: 'string'
            },
            {
              name: 'asString',
              type: 'boolean',
              defaultValue: false
            },
            {
              name: 'ourProduct',
              type: 'string',
              showIf: `options.get('asString')`,
              defaultValue: true
            },
            {
              name: 'ourProduct',
              type: 'boolean',
              showIf: `!options.get('asString')`,
              defaultValue: true
            },
            {
              name: 'competitor',
              type: 'string',
              showIf: `options.get('asString')`,
              defaultValue: true
            },
            {
              name: 'competitor',
              type: 'boolean',
              showIf: `!options.get('asString')`,
              defaultValue: true
            },
          ]
        }
      ]
    }
  ]
});
